import { useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "../../GameSelector.module.css";

interface Props {
  onClickNewGame: () => void;
  onClickJoinGame: () => void;
}

function StartGameOptions({ onClickNewGame, onClickJoinGame }: Props) {
  const [isNewGameSelected, setIsNewGameSelected] = useState<boolean>(false);
  const [isJoinGameSelected, setIsJoinGameSelected] = useState<boolean>(false);

  const { t } = useTranslation();

  function handleOnClickNewGame() {
    setIsNewGameSelected(true);
    onClickNewGame();
  }

  function handleOnClickJoinGame() {
    setIsJoinGameSelected(true);
    onClickJoinGame();
  }

  function isButtonDisabled() {
    return isNewGameSelected || isJoinGameSelected;
  }

  return (
    <div className="StartGameOptions">
      <h2 className={styles.title}>{t("StartGameOptions.title")}</h2>
      <div className={styles.body}>
        <div className={styles.option}>
          {isNewGameSelected ? (
            <button
              className={[styles.button, "loading-state"].join(" ")}
              disabled
            >
              {t("App.loading")}
            </button>
          ) : (
            <button
              className={styles.button}
              onClick={handleOnClickNewGame}
              onKeyUp={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleOnClickNewGame();
                }
              }}
              disabled={isButtonDisabled()}
            >
              {t("StartGameOptions.newGame")}
            </button>
          )}
          <div className={styles.description}>
            {t("StartGameOptions.newGameDesc")}
          </div>
        </div>

        <div className={styles.option}>
          {isJoinGameSelected ? (
            <button
              className={[styles.button, "loading-state"].join(" ")}
              disabled
            >
              {t("App.loading")}
            </button>
          ) : (
            <button
              className={styles.button}
              onClick={handleOnClickJoinGame}
              onKeyUp={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleOnClickJoinGame();
                }
              }}
              disabled={isButtonDisabled()}
            >
              {t("StartGameOptions.joinGame")}
            </button>
          )}
          <div className={styles.description}>
            {t("StartGameOptions.joinGameDesc")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StartGameOptions;
